

module.exports = __webpack_require__.stylable.create(
    "FullWidthTextArea241150047",
    {"classes":{"root":"FullWidthTextArea241150047__root"},"vars":{},"stVars":{},"keyframes":{}},
    "",
    14,
    "FullWidthTextArea241150047",
    null
);
